export default __webpack_public_path__ + "images/patientEducationSVG2.bbbce340ba68caebf65c48db1e9d342b.svg";